import * as M from '@mantine/core';
import { DatePickerInput } from '@mantine/dates';
import { IconCalendar } from '@tabler/icons-react';
import type { IModemFilterForm } from '../../../../../../shared/types/modem';
import { InfoField } from '../../../../../ui/infoField/InfoField';

interface IPropsModemFilterSection {
  filterForm: IModemFilterForm;
  onChangeFilterForm: (nextFilter: Partial<IModemFilterForm>) => void;
  onSearch: () => void;
  onReset: () => void;
}

const activationStatusOptions = [
  { value: 'INPROGRESS', label: '진행중' },
  { value: 'COMPLETED', label: '개통 완료' },
  { value: 'FAILED', label: '막힘' },
  { value: 'PENDING', label: '진행전' },
  { value: 'CANCELED', label: '해지' },
];

export default function ModemFilterSection(props: IPropsModemFilterSection) {
  const { filterForm, onChangeFilterForm, onSearch, onReset } = props;

  const onChangeActivationStatus = (value: string, checked: boolean) => {
    if (!checked) {
      onChangeFilterForm({
        activationStatuses: filterForm.activationStatuses.filter((status) => status !== value),
      });
      return;
    }

    const nextStatuses = [...filterForm.activationStatuses, value];

    onChangeFilterForm({
      activationStatuses: nextStatuses.length === activationStatusOptions.length ? [] : nextStatuses,
    });
  };

  return (
    <M.Box
      style={{
        borderTop: '1px solid var(--mantine-color-gray-3)',
        borderLeft: '1px solid var(--mantine-color-gray-3)',
      }}
    >
      <M.SimpleGrid cols={2} spacing={0} verticalSpacing={0} style={{ gridTemplateColumns: '180px minmax(0, 1fr)' }}>
        <InfoField label="개통일자" labelAlign="left" contentAlign="left">
          <M.Flex align="center" gap="md" wrap="wrap" w="100%">
            <M.Flex gap="xs" align="center" wrap="wrap">
              <DatePickerInput
                leftSection={<IconCalendar size={14} />}
                placeholder="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD"
                w={210}
                value={filterForm.startDate}
                onChange={(date) => onChangeFilterForm({ startDate: date })}
              />
              <M.Text c="gray.7">-</M.Text>
              <DatePickerInput
                leftSection={<IconCalendar size={14} />}
                placeholder="YYYY-MM-DD"
                valueFormat="YYYY-MM-DD"
                w={210}
                value={filterForm.endDate}
                onChange={(date) => onChangeFilterForm({ endDate: date })}
              />
            </M.Flex>
            <M.Checkbox
              label="약정 만료된 모뎀"
              checked={filterForm.expiredContractOnly}
              onChange={(event) => onChangeFilterForm({ expiredContractOnly: event.currentTarget.checked })}
            />
          </M.Flex>
        </InfoField>
        <InfoField label="개통 진행 상태" labelAlign="left" contentAlign="left">
          <M.Flex gap="lg" wrap="wrap">
            <M.Radio
              label="전체"
              size="sm"
              checked={filterForm.activationStatuses.length === 0}
              onChange={() => onChangeFilterForm({ activationStatuses: [] })}
            />
            {activationStatusOptions.map((option) => (
              <M.Checkbox
                key={option.value}
                label={option.label}
                size="sm"
                checked={filterForm.activationStatuses.includes(option.value)}
                onChange={(event) => onChangeActivationStatus(option.value, event.currentTarget.checked)}
              />
            ))}
          </M.Flex>
        </InfoField>
        <InfoField label="상세 검색" labelAlign="left" contentAlign="left">
          <M.Flex gap="sm" align="center" wrap="wrap" w="100%">
            <M.TextInput
              w={400}
              placeholder="단말기 일련번호/MAC 번호/USIM 일련번호로 검색"
              value={filterForm.keyword}
              onChange={(event) => onChangeFilterForm({ keyword: event.currentTarget.value })}
            />
            <M.Button variant="filled" color="primary.5" onClick={onSearch}>
              조회
            </M.Button>
            <M.Button variant="default" onClick={onReset}>
              초기화
            </M.Button>
          </M.Flex>
        </InfoField>
      </M.SimpleGrid>
    </M.Box>
  );
}
